import { NavigationAppsProvider } from 'modules/design-system';
import { SidenavProvider } from 'modules/sidenav/context/SidenavContext';
import { FeatureFlagsProvider } from './feature-flags/FeatureFlagsContext';
import { NavigationMenuProvider } from './navigation-menu/NavigationMenuContext';
import { OutdatedAppProvider } from './outdated-app/OutdatedAppContext';
import { ColorSchemeProvider } from './theme/ColorSchemeContext';
import { ThemeProvider } from './theme/ThemeProvider';

export const ContextProviders: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <OutdatedAppProvider>
      <ColorSchemeProvider>
        <FeatureFlagsProvider>
          <NavigationMenuProvider>
            <SidenavProvider>
              <ThemeProvider>
                <NavigationAppsProvider>{children}</NavigationAppsProvider>
              </ThemeProvider>
            </SidenavProvider>
          </NavigationMenuProvider>
        </FeatureFlagsProvider>
      </ColorSchemeProvider>
    </OutdatedAppProvider>
  );
};
